import {NgModule} from '@angular/core';
import {DepartmentTreeComponent} from './departments.component';
import {SharedModule} from '../../_shared/shared.module';
import {Daterangepicker} from 'ng2-daterangepicker';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import { ExpandMode, NgxTreeSelectModule } from 'ngx-tree-select';
// import {TreeviewModule} from 'ngx-treeview';
@NgModule({
  imports: [
    SharedModule,
    Daterangepicker,
    AngularMultiSelectModule,
    // TreeviewModule.forRoot(),
    NgxTreeSelectModule.forRoot(
        {
          idField: '_id',
          textField: 'name',
          expandMode: ExpandMode.All
        })
  ],
  declarations: [DepartmentTreeComponent],
  exports: [DepartmentTreeComponent]
})
export class DepartmentTreeModule {
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/department-tree/departments.module.ts